import { useEffect, useState } from 'react';
import { estadoInstalacion, suscribirseInstalacion, instalarApp } from '../utils/installPrompt';

export function useInstallPrompt() {
  const [estado, setEstado] = useState(estadoInstalacion);

  useEffect(() => suscribirseInstalacion(() => setEstado(estadoInstalacion())), []);

  return { ...estado, instalar: instalarApp };
}
